import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask100To199Service {

  constructor() { }
}
